
import { i18nText } from '@/locales';

import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {Component, Prop, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {ProxyTableData} from "@/UI/components/Helpers/ProxyTableData";
import {ServiceCategoryMix} from "@/UI/mixins/Service/ServiceCategoryMix";
import {ServicesMix} from "@/UI/mixins/Service/ServicesMix";
import {Button, Col, FormModel, Modal, Row, Table, Tabs, Tree} from "ant-design-vue";
import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {ServiceCreateRequestType} from "@/form/serviceCreate/serviceCreate.types";
import {ServiceStore} from "@/store/modules/Services";
import {showNotification, showNotificationSimple} from "@/UI/lib/messages";
import {RouterNameEnum} from "@/router/router.types";
import {FormRules,} from "@/form/serviceCategory/serviceCategory";
import {getStudioId} from "@/UI/lib/state";
import {TreeTransfer} from "@/UI/lib/calculte";
import {ServiceNomenclatureStore} from "@/store/modules/ServicesNomenclature";
import {IServicesNomenclaturesTree} from "@/entity/servicesNomenclature/services.nomenclature.types";
import TabCustom from "@/UI/components/common/TabCustom.vue";
import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import {appPaginationStore} from "@/store/modules/appPagination";
import {ProxyGetData} from "@/UI/components/Helpers/getData";

@Component({
  components: {
    TabCustom,
    PageTitle,
    BaseDataForm,
    "a-tab": Tabs,
    "a-tab-pane": Tabs.TabPane,
    "a-table": Table,
    "a-col": Col,
    "a-row": Row,
    "a-button": Button,
    "a-modal": Modal,
    "a-tree": Tree,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
    SortComponent
  },
})
export default class ServiceIndex extends mixins(ProxyTableData, ServiceCategoryMix, ServicesMix, ProxyGetData) {
  @Prop() readonly mode!: number;

  rules = FormRules;
  requestProceed = false;
  isPartner: any = {}
  servicesTree = new TreeTransfer();
  sValue = "";
  sData = {};
  servicesModal: boolean = false;
  treeData: any = []

  get tree(): IServicesNomenclaturesTree[] {
    return ServiceNomenclatureStore.tree;
  }

  startRequest(): void {
    this.requestProceed = true;
  }

  stopRequest(): void {
    this.requestProceed = false;
  }

  async showServices(): Promise<void> {
    this.treeData = []
    await ServiceNomenclatureStore.getTree();
    if (this.tree) {
      for (const treeItem of this.tree) {
        this.treeData.push(treeItem);
      }
    }

    this.servicesModal = true;
  }

  serviceCopyCancel(): void {
    this.servicesModal = false;
  }

  async proceedServiceCopy(): Promise<void> {
    try {
      this.startRequest();
      let copyData: string[];
      copyData = this.servicesTree.parseDataWithAllkeys();
      showNotificationSimple(i18nText("Начато  копирование услуг..."), "", 10);

      const response = await ServiceStore.copy({services: copyData, salon_id: getStudioId(this)});

      if (response.status) {
        this.$notification.success({
          message: i18nText("Успешно"),
          description: response["response"],
          duration: 0,
        });
        await this.getData();
      } else {
        this.$notification.error({
          message: i18nText("Ошибка"),
          description: response["response"],
          duration: 0,
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.stopRequest();
      this.serviceCopyCancel()
      this.treeData = []
    }
  }

  async searchServices(): Promise<void> {
    try {
      this.startRequest();
      await ServiceNomenclatureStore.getTree({name: this.sValue});
    } catch (e) {
      console.error(e);
    } finally {
      this.stopRequest();
    }
  }

  onServiceCheck(checkedKeys: Array<any>): void {
    this.servicesTree.setValue(checkedKeys);
  }

  linkToService(record: Record<string, any>): any {
    return {
      name: RouterNameEnum.ServicePartnerDetail,
      params: {id: record["id"]},
    };
  }

  async deleteServiceCategoryPartner(record: Record<string, any>, mode: number): Promise<void> {
    if (mode === 2) {
      await ServiceStore.delete({id: record.id}).then((response) => {
        showNotification(i18nText("Услуга удалена"), response);
      });
    }
    if (mode === 1) {
      await ServicesCategoryStore.delete({id: record.id}).then((response) => {
        showNotification(i18nText("Категория удалена"), response);

        this.AppPageParams.total -= 1;
        if(Number(this.AppPageParams.total) % Number(this.AppPageParams.pageSize) === 0) {
          if(this.AppPageParams.current > 1) { this.AppPageParams.current--; }
        }
      });
    }

    await this.handleTableChange(this.AppPageParams);
    //await this.getData()
    /*if(Number(this.$router.currentRoute.params.total) != this.AppPageParams.total) {
      await this.$router.push({
        name: this.$router.currentRoute?.meta?.props.source.routePage,
        params: {
          page: (this.AppPageParams.current > 1 ? this.AppPageParams.current - 1 : 1).toString(),
          page_size: this.AppPageParams.pageSize.toString(),
          total: this.AppPageParams.total.toString(),
          filter: this.$router.currentRoute.params.filter,
        },
      });
    }*/

  }

  editService(record: Record<string, any>): void {
    const newData = [...(this.$refs["serviceTable"] as Table).dataSource];
    const target = newData.filter((item) => record === item.id)[0];
    if (target) {
      target.editable = !target.editable;
      (this.$refs["serviceTable"] as Table).dataSource = newData;
    }
  }

  changeRecord(record: ServiceCreateRequestType): void {
    try {
      ServiceStore.update(record).then((response) => {
        showNotification(i18nText("Запись обновлена"), response);
      });
    } catch (e) {
      console.log(i18nText("Ошибка обновления"));
    }
  }

  get servicesCategoryColumns(): ITableColumn[] {
    return TablesStore.servicesCategoryColumnsPartner;
  }

  get serviceExtColumns(): ITableColumn[] {
    return TablesStore.servicesExtColumns;
  }

  customCategoryServiceRow = () => {
    return {
      on: {
        click: (event: any) => {
          console.log(event);
        },
      },
    };
  };

  async tabChanged(key: string): Promise<void> {
    await this.$router.push({name: key, params: {Studio: "0"}});
  }

  servicesTabs = [
    {
      id: RouterNameEnum.Services,
      name: i18nText("Услуги"),
      //params: { Studio: "0" },
    },
    {
      id: RouterNameEnum.PartnerServices,
      name: i18nText("Услуги партнеров"),
    },
  ];


  async created(): Promise<void> {
    try {
      this.AppPageParams.current = 1;
      this.AppPageParams.pageSize = 10;
      this.AppPageParams.total = 0;
      this.formReady = false;
      this.isPartner = {
        owner: Vue.auth.check('owner'),
        network: Vue.auth.check('network')
      }
      await this.sortedData('desc', {dataIndex: 'created_at'})
      await this.fetchModules([
        {s: 'category', p: {limit: -1}}
      ])
      await this.getData();
    } catch (e) {
      console.error(e);
    } finally {
      this.formReady = true;
    }
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    await this.sortedData(by, {dataIndex: sort.dataIndex})
  }
}
